import { DiscoEmptyState, DiscoIcon } from "@disco-ui"
import React from "react"

interface ProductMembersListNoneFoundProps {
  title: string
  button?: React.ReactNode
}

function MembersListNoneFound({ title, button }: ProductMembersListNoneFoundProps) {
  return (
    <DiscoEmptyState
      testid={"ProductMemberListContainer"}
      icon={<DiscoIcon icon={"user"} />}
      title={title}
      subtitle={"If using filters, try removing some to see more."}
      buttons={button}
    />
  )
}

export default MembersListNoneFound
